module.exports = __webpack_public_path__ + "assets/img/8.bc890e7e.jpg";